import { lazyWithPreload } from '@kk/shared/utils/async';
import type { ExtendedRouteObject } from '@/routes/types';
import DeliveryApprovalsPage from './index';
import loader, { type LoaderData, type Params } from './loader';

const DeliveryApprovals = lazyWithPreload(
  () => import('./DeliveryAppovals/DeliveryApprovals'),
);

const DeliveryApprovalDetails = lazyWithPreload(
  async () =>
    await import('./DeliveryAppovals/Details/DeliveryApprovalDetails'),
);

export default {
  id: 'delivery-approvals',
  path: '/deliveryapprovals',
  element: <DeliveryApprovalsPage />,
  loader,
  children: [
    {
      id: 'approvals',
      index: true,
      element: <DeliveryApprovals />,
    },
    {
      id: 'details',
      path: ':entryId',
      element: <DeliveryApprovalDetails />,
    },
    {
      id: 'anonymous',
      path: ':paramA/:paramB',
      element: <DeliveryApprovalDetails />,
    },
  ],
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
